import { Stack, styled, Typography } from '@mui/material';

export const StyledCard = styled(Stack)(({ theme }) => {
  return {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    margin: theme.spacing(0.5, 0.5, 2, 0.5),
    alignItems: 'center',
    background: 'transparent',
    borderRadius: 'none',
    padding: theme.spacing(4, 8),
    borderTop: '1px solid white',
    gap: theme.spacing(2),
    [':first-child']: {
      borderTop: 'none',
    },
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(2, 3),
      margin: theme.spacing(0.5, 0.5, 3, 0.5),
    },
  };
});

export const StyledTitle = styled(Typography)(({}) => ({
  letterSpacing: '-0.02em',
  textTransform: 'uppercase',
  fontWeight: 'bold',
  width: '100%',
}));
